import React, { useEffect, useState } from 'react';
import { Modal, Icon, Tooltip, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchACCPSupervisor, fetchACCPSupervisorAvailable, fetchACCPSupervisorFilter, accpSupervisorClear, accpSupervisorFilterClear } from 'app/actions/ACCPSupervisorActions';
import { getACCPSupervisor, getACCPSupervisorAvailable, getACCPSupervisorFilter, getIsLoadingACCPSupervisor, getIsLoadingACCPSupervisorAvailable } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function ACCPSupervisorTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;
    const { siteId } = useSelector(state => state.Auth)

    let searchInput = React.createRef();
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {

            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            sorter: true,
            width: 150,
            ellipsis: true,
        },
        {

            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            ellipsis: true,
            width: 250

        },
        {
            title: 'Compañía',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            width: 200,
            ellipsis: true

        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            width: 380,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'employeeId',
            fixed: 'right',
            width: siteId === "HUB" ? 120 : 80,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === "HUB" ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            : null
                    }
                </div>
            )
        }
    ];

    const columnsNew = [
        {
            ...getColumnSearchProps('employeeId'),
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            width: 100,
            ellipsis: true,
            sorter: (a, b) => a.employeeId - b.employeeId,

        },
        {
            ...getColumnSearchProps('employeeName'),
            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            width: 300,
            ellipsis: true,
            sorter: (a, b) => a.employeeName.localeCompare(b.employeeName)

        },
        /* {
             title: 'Compañía',
             dataIndex: 'subdirectionName',
             key: 'subdirectionName',
             sorter: true,
             width: 200,
             ellipsis: true
 
         },
         {
             title: 'Puesto',
             dataIndex: 'categoryName',
             key: 'categoryName',
             sorter: true,
             width: 200,
             ellipsis: true
 
         }*/
    ];
    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Supervisor de AC y CP?',
            content: param.employeeId + ' - ' + param.employeeName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.employeeName));
                return deleteSupervisor(param);
            },
            onCancel() { },
        });

    }

    async function deleteSupervisor(param) {
        await ApiService.setEmployeeSupervisor({ supervisor: false, listEmployeeId: [param.employeeId] }, 'PUT').then(res => {
            dispatch(accpSupervisorFilterClear());
            dispatch(fetchACCPSupervisorFilter());
            dispatch(accpSupervisorClear());
            //fetchACCPSupervisorAction();

            dispatch(fetchACCPSupervisor({
                employee: props.FiltroNombre.filter(x => x !== param.employeeName).join(','),
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));

            fetchACCPSupervisorAvailableAction();
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let accpSupervisor = useSelector(getACCPSupervisor);
    let accpSupervisorAvailable = useSelector(getACCPSupervisorAvailable);
    let accpSupervisorFilter = useSelector(getACCPSupervisorFilter);

    let isLoading = useSelector(getIsLoadingACCPSupervisor);
    let isLoadingAvailable = useSelector(getIsLoadingACCPSupervisorAvailable);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(accpSupervisor)) fetchACCPSupervisorAction();
        if (isEmpty(accpSupervisorAvailable)) fetchACCPSupervisorAvailableAction();
        if (isEmpty(accpSupervisorFilter)) fetchACCPSupervisorFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchACCPSupervisor(
            {
                employee: props.FiltroNombre.join('|'),
                CommunicationProgramName: (typeof props.formData.CommunicationProgramName === "undefined") ? '' : props.formData.CommunicationProgramName,
                CommunicationProgramDescription: (typeof props.formData.CommunicationProgramDescription === "undefined") ? '' : props.formData.CommunicationProgramDescription,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };


    function getColumnSearchProps(dataIndex) {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Buscar...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Buscar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpiar
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            }
        }
    }

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
    };

    const handleReset = clearFilters => {
        clearFilters();
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && accpSupervisor.length > 0) {
            pagination.total = accpSupervisor[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchACCPSupervisorAction = () => dispatch(fetchACCPSupervisor({
        employee: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchACCPSupervisorAvailableAction = () => dispatch(fetchACCPSupervisorAvailable())
    const fetchACCPSupervisorFilterAction = () => dispatch(fetchACCPSupervisorFilter())
    accpSupervisorAvailable.map(item => item['key'] = item.employeeId);
    return (props.children({ pagination: pagination, cols: columns, columnsNews: columnsNew, accpSupervisor, accpSupervisorAvailable, accpSupervisorFilter, isLoading, isLoadingAvailable, handleTableChange: handleTableChange }));
}

